
import { takeLatest, put, call, select } from 'redux-saga/effects';
import api from '../../api/api';
import * as types from '../types';
import { fetchMenuFailure } from '../actions/menu_actions';

// Helper to check if session is over (1 hour for example)
function isSessionOver(lastFetched) {
  if (!lastFetched) return true;
  const now = Date.now();
  // 1 hour session (3600000 ms)
  return now - lastFetched > 3600000;
}

function* fetchMenuSaga(action) {
  try {
    const { menu } = yield select(state => state.menu);
    const language = action.language || 'english';
      const cached = menu[language];
      if (cached && cached.data && cached.data.length > 0 && !isSessionOver(cached.lastFetched)) {
        // Serve from cache, no API call
        yield put({ type: types.FETCH_MENU_SUCCESS, payload: cached.data, language });
        return;
      }
    const response = yield call(api.get, `/menu/${language}`);
    yield put({ type: types.FETCH_MENU_SUCCESS, payload: response.data, language });
  } catch (error) {
    yield put(fetchMenuFailure(error.message || 'Failed to fetch menu'));
  }
}

export function* watchFetchMenu() {
  yield takeLatest(types.FETCH_MENU_REQUEST, fetchMenuSaga);
}
